'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    display: none !important;\n  '], ['\n    display: none !important;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    text-align: left;\n    margin: 35px 0;\n  '], ['\n    text-align: left;\n    margin: 35px 0;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _bottomBlob = require('bender-url!pricing-pages-unified-ui/img/bottom-blob.svg');

var _bottomBlob2 = _interopRequireDefault(_bottomBlob);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledQuestionBackground = (0, _styledComponents2.default)(_UIImage2.default).withConfig({
  displayName: 'Faq__StyledQuestionBackground'
})(['position:absolute;padding-bottom:80px;margin-top:-24px;', ';'], _responsiveBreakpoints2.default.phone(_templateObject));

var QuestionContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Faq__QuestionContainer'
})(['max-width:1004px;margin-right:auto;margin-left:auto;position:relative;padding-top:40px;clear:both;']);

var QuestionContent = _styledComponents2.default.div.withConfig({
  displayName: 'Faq__QuestionContent'
})(['z-index:1;position:relative;']);

var Title = _styledComponents2.default.h1.withConfig({
  displayName: 'Faq__Title'
})(['font-weight:bold;line-height:44px;text-align:center;margin-top:75px;margin-bottom:35px;', ';'], _responsiveBreakpoints2.default.phone(_templateObject2));

var Faq = function Faq(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    QuestionContainer,
    null,
    _react2.default.createElement(StyledQuestionBackground, { src: _bottomBlob2.default }),
    _react2.default.createElement(
      QuestionContent,
      null,
      _react2.default.createElement(
        Title,
        null,
        _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.faq.title' })
      ),
      children
    )
  );
};

Faq.propTypes = {
  children: _react.PropTypes.node.isRequired
};

exports.default = Faq;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/Faq.js
// module id = 215
// module chunks = 3 4